import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {userRegister} from "../../services/userRegister";
import {langRegister} from "../../services/langRegister";
import queryString from 'query-string';
import {salesChannelRegister} from "../../services/salesChannelRegister";
import countryCodes from "country-telephone-data";
import {marketRegister} from "../../services/marketRegister";
import BoosterHeader from "../../components/booster-header/component";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import ModalImageSize from "../../components/modal-imagesize/component";
import ModalProfileImageSize from "../../components/modal-profileimagesize/component";

class BoosterRegister extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoadingButton: false,
            error: false,
            dropdown: false,
            email: "",
            password: "",
            name: "",
            phone: "",
            permit: "",
            company_name: "",
            countries: [],
            country: {},
            tab: 'company'
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateCountries();
        //document.addEventListener("keydown", this._handleKeyDown.bind(this));

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/register');
            ReactGA4.send({ hitType: "pageview", page: "/register" });
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
    }

    componentWillUnmount() {
        //document.removeEventListener("keydown", this._handleKeyDown.bind(this));
    }

    _updateCountries() {
        let countries = JSON.parse(JSON.stringify(countryCodes.allCountries));
        for (let i = 0; i < countries.length; i++) {
            countries[i].dialCode = "+" + countries[i].dialCode;
            if (countries[i].iso2 === salesChannelRegister.get("market")) {
                this._selectCountry(countries[i]);
            }
        }
        this.setState({countries: countries});
    }

    _handleKeyDown(event) {
        var ENTER_KEY = 13;
        switch (event.keyCode) {
            case ENTER_KEY:
                this._register();
                break;
            default:
                break;
        }
    }

    _login() {
        try {
            let query = queryString.parse(this.props.location.search);
            if (query.from_path) {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login?from_path=" + query.from_path);
            } else if (query.to) {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login?from_path=" + query.to);
            } else {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
            }
        } catch (e) {
            console.log(e)
        }
    }

    _register() {

        let permit = false;
        if (salesChannelRegister.get('name') !== "boostabostad") {
            if (this.state.permit !== "") {
                permit = true;
            }
        } else {
            permit = true;
        }

        if (this.state.password !== "" && this.state.email !== "" && ((this.state.tab === 'company' && this.state.first_name !== "" && this.state.last_name !== "" && this.state.phone !== "" && this.state.country.dialCode !== "" && permit && this.state.company_name !== "") || this.state.tab === 'private')) {
            this.setState({isLoadingButton: true, error: false});

            const formData = new FormData();
            formData.append("email", this.state.email);
            formData.append("password", this.state.password);
            formData.append("name", this.state.first_name ? this.state.first_name : "");
            formData.append("surname", this.state.last_name ? this.state.last_name : "");
            formData.append("billing_company", this.state.company_name);
            formData.append("vat_no", this.state.permit);
            formData.append("phone", this.state.country.dialCode ? (this.state.country.dialCode + this.state.phone) : this.state.phone);
            formData.append("signup_type", this.state.tab ? this.state.tab : "");
            if (langRegister.lang()) {
                try {
                    formData.append("lang", langRegister.lang().toLowerCase());
                } catch (e) {
                }
            }

            if (this.state.broker_image_file) {
                formData.append("logo", this.state.broker_image_file);
            }

            dataRegister.signUp(salesChannelRegister.get('market'), formData).then((response) => {
                if (!response.errors) {
                    response.email = this.state.email;
                    userRegister.set(response);

                    if (salesChannelRegister.get('name') === "yieldlock") {

                        //GOOGLE EVENT
                        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                            ReactGA.event({category: 'User', action: 'Signed Up', label: 'Register'});
                            ReactGA4.event({category: 'User', action: 'Signed Up', label: 'Register'});
                        }

                        //FACEBOOK EVENT
                        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                            ReactPixel.track('CompleteRegistration');
                        }

                    } else {

                        if (this.state.tab === "company") {
                            //GOOGLE EVENT
                            if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                                ReactGA.event({category: 'User', action: 'Signed Up Company', label: 'Register'});
                                ReactGA4.event({category: 'User', action: 'Signed Up Company', label: 'Register'});
                            }

                            //FACEBOOK EVENT
                            if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                                ReactPixel.trackCustom('CompleteRegistrationCompany');
                            }
                        } else {
                            //GOOGLE EVENT
                            if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                                ReactGA.event({category: 'User', action: 'Signed Up Individual', label: 'Register'});
                                ReactGA4.event({category: 'User', action: 'Signed Up Individual', label: 'Register'});
                            }

                            //FACEBOOK EVENT
                            if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
                                ReactPixel.trackCustom('CompleteRegistrationIndividual');
                            }
                        }
                    }


                    let query = queryString.parse(this.props.location.search);
                    if (query.from) {
                        this.props.history.push(query.from);
                    } else if (query.from_path) {
                        this.props.history.push(query.from_path);
                    } else {
                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/running");
                    }
                } else {
                    this.setState({isLoadingButton: false, error: true});
                }
            }, (error) => {
                this.setState({isLoadingButton: false, error: true});
            });
        } else {
            this.setState({
                error: true
            });
        }
    }

    _selectCountry(option) {
        this.setState({country: option, search: option.dialCode});
    }

    _renderButton() {
        if (!this.state.isLoadingButton) {
            return (this._renderText("item_5"));
        } else {
            return (<BeatLoader size={9} color={'#ffffff'} loading={true}/>);
        }
    }


    _renderText(item) {
        return langRegister.get("register", item);
    }

    _addProfilePicture(e) {
        try {
            if (e.target.files && e.target.files.length > 0) {
                if (e.target.files[0].size < 2000000) {
                    let file = e.target.files[0];
                    this.setState({
                        broker_image_file: file
                    }, () => {
                        const reader = new FileReader();
                        reader.addEventListener("load", () =>
                            this.setState({
                                broker_image: reader.result
                            })
                        );
                        reader.readAsDataURL(file);
                    })
                } else {
                    this.setState({
                        size_modal: true
                    })
                }
            }
        } catch (error) {
        }
    }

    render() {
        return (
            <div>
                <BoosterHeader view={"register"} props={this.props}/>
                {
                    this.state.size_modal &&
                    <ModalProfileImageSize setLeave={() => {
                        this.setState({
                            size_modal: false,
                            broker_image: false,
                            broker_image_file: false
                        })
                    }}/>
                }
                <div className={Styles.container}>
                    <div style={salesChannelRegister.get('name') === "yieldlock" ? {color: '#E65032'} : {}}
                         className={Styles.title}>
                        {this._renderText("item_1")}
                    </div>
                    <div className={Styles.subtitle}>
                        {this._renderText("item_2")}
                    </div>
                    <div className={Styles.inputWrapper}>
                        <div className={Styles.inputWrapperInner}>
                            {
                                salesChannelRegister.get('name') !== "yieldlock" &&
                                <div className={cx(Styles.tabsContainer)}>
                                    <div onClick={() => this.setState({tab: "company"})} className={
                                        cx(Styles.tabsContainerItem,
                                            {
                                                [Styles.tabsContainerItemActive]: this.state.tab === "company",
                                            })
                                    }>
                                        {this._renderText("item_14")}
                                    </div>
                                    <div onClick={() => this.setState({tab: "private"})} className={
                                        cx(Styles.tabsContainerItem,
                                            {
                                                [Styles.tabsContainerItemActive]: this.state.tab === "private",
                                            })
                                    }>
                                        {this._renderText("item_15")}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    {
                        this.state.tab === "company" &&
                        <div className={Styles.imageWrapper}>
                            <div className={cx(Styles.brokerInformationImage, Styles.brokerInformationImageMobile)}>
                                <div style={{backgroundImage: "url(" + this.state.broker_image + ")"}}
                                     className={Styles.brokerInformationImageItem}>
                                    {
                                        <div className={Styles.brokerInformationImageItemLargePlus}>
                                            <input
                                                ref="uploadImageFile" onClick={() => this.refs.uploadImageFile.value = null}
                                                onChange={(e) => this._addProfilePicture(e)}
                                                type="file" accept="image/jpeg, image/png"
                                                className={Styles.brokerInformationImageItemPlusUpload}/>
                                            {
                                                !this.state.broker_image &&
                                                <span>
                                                +
                                                </span>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                    <div className={Styles.inputWrapper}>
                        <div className={Styles.inputWrapperInner}>
                            <div className={Styles.inputWrapperInnerSplit}>
                                <input
                                    className={
                                        cx(Styles.input, Styles.firstname)
                                    }
                                    placeholder={this.state.tab === "company" ? this._renderText("item_8") + "*" : this._renderText("item_8")}
                                    value={this.state.first_name}
                                    onChange={(event) => this.setState({first_name: event.target.value})}
                                />
                                {
                                    this.state.error && this.state.tab === "company" &&
                                    <div
                                        style={salesChannelRegister.get('name') === "yieldlock" ? {backgroundColor: '#E65032'} : {}}
                                        className={Styles.inputError}/>
                                }
                            </div>
                            <div className={Styles.tabsSpace}></div>
                            <div className={Styles.inputWrapperInnerSplit}>
                                <input
                                    className={
                                        cx(Styles.input, Styles.lastname)
                                    }
                                    placeholder={this.state.tab === "company" ? this._renderText("item_11") + "*" : this._renderText("item_11")}
                                    value={this.state.last_name}
                                    onChange={(event) => this.setState({last_name: event.target.value})}
                                />
                                {
                                    this.state.error && this.state.tab === "company" &&
                                    <div
                                        style={salesChannelRegister.get('name') === "yieldlock" ? {backgroundColor: '#E65032'} : {}}
                                        className={Styles.inputError}/>
                                }
                            </div>
                        </div>
                    </div>
                    <div className={Styles.inputWrapper}>
                        <div className={Styles.inputWrapperInner}>
                            <div className={Styles.inputWrapperInnerDropDown}>
                                <input
                                    placeholder={this.state.tab === "company" ? this._renderText("item_10") + "*" : this._renderText("item_10")}
                                    type="tel"
                                    onFocus={() => this.setState({dropdown: true})}
                                    onBlur={() => this.setState({dropdown: false})}
                                    value={this.state.search}
                                    onChange={(event) => this.setState({search: event.target.value})}
                                    style={salesChannelRegister.get('name') === "yieldlock" ? {color: '#00273A'} : {}}
                                    className={Styles.inputWrapperInnerDropDownInput}
                                />
                                {
                                    this.state.error && this.state.tab === "company" &&
                                    <div
                                        style={salesChannelRegister.get('name') === "yieldlock" ? {backgroundColor: '#E65032'} : {}}
                                        className={Styles.inputError}/>
                                }
                                {
                                    this.state.dropdown && this.state.countries.filter((item) => {
                                        return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                    }).length > 0 &&
                                    <div className={Styles.dropdownList}>
                                        {
                                            this.state.countries.filter((item) => {
                                                return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                            }).map((prop, key) => {
                                                return (
                                                    <div key={key}
                                                         onMouseDown={() => this._selectCountry(prop)}
                                                         style={salesChannelRegister.get('name') === "yieldlock" ? {color: '#00273A'} : {}}
                                                         className={Styles.dropdownListItem}>
                                                        {prop.dialCode}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                }
                            </div>
                            <div className={Styles.inputWrapperInnerInput}>
                                <input
                                    type="tel"
                                    value={this.state.phone}
                                    onChange={(event) => this.setState({phone: event.target.value.trim()})}
                                    className={Styles.input}
                                    placeholder={this.state.tab === "company" ? this._renderText("item_9") + "*" : this._renderText("item_9")}
                                />
                                {
                                    this.state.error && this.state.tab === "company" &&
                                    <div
                                        style={salesChannelRegister.get('name') === "yieldlock" ? {backgroundColor: '#E65032'} : {}}
                                        className={Styles.inputError}/>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        this.state.tab === 'company' &&
                        <div className={Styles.inputWrapper}>
                            <input
                                className={
                                    cx(Styles.input)
                                }
                                type={"text"}
                                placeholder={this._renderText("item_12")}
                                value={this.state.company_name}
                                onChange={(event) => this.setState({company_name: event.target.value})}
                            />
                            {
                                this.state.error &&
                                <div
                                    style={salesChannelRegister.get('name') === "yieldlock" ? {backgroundColor: '#E65032'} : {}}
                                    className={Styles.inputError}/>
                            }
                        </div>
                    }
                    {
                        this.state.tab === 'company' &&
                        <div className={Styles.inputWrapper}>
                            <input
                                className={
                                    cx(Styles.input)
                                }
                                type={"text"}
                                placeholder={this._renderText("item_13")}
                                value={this.state.permit}
                                onChange={(event) => this.setState({permit: event.target.value})}
                            />
                            {
                                this.state.error &&
                                <div
                                    style={salesChannelRegister.get('name') === "yieldlock" ? {backgroundColor: '#E65032'} : {}}
                                    className={Styles.inputError}/>
                            }
                        </div>
                    }
                    <div className={Styles.inputWrapper}>
                        <input
                            className={
                                cx(Styles.input)
                            }
                            type={"email"}
                            placeholder={this._renderText("item_3")}
                            value={this.state.email}
                            onChange={(event) => this.setState({email: event.target.value.toLowerCase()})}
                        />
                        {
                            this.state.error &&
                            <div
                                style={salesChannelRegister.get('name') === "yieldlock" ? {backgroundColor: '#E65032'} : {}}
                                className={Styles.inputError}/>
                        }
                    </div>
                    <div className={Styles.inputWrapper}>
                        <input
                            className={
                                cx(Styles.inputPassword)
                            }
                            type={"password"}
                            placeholder={this._renderText("item_4")}
                            value={this.state.password}
                            onChange={(event) => this.setState({password: event.target.value})}
                        />
                        {
                            this.state.error &&
                            <div
                                style={salesChannelRegister.get('name') === "yieldlock" ? {backgroundColor: '#E65032'} : {}}
                                className={Styles.inputError}/>
                        }
                    </div>
                    <div onClick={() => this._register()} className={Styles.button}>
                        {this._renderButton()}
                    </div>
                    <div className={Styles.text}>
                        {this._renderText("item_6")}<span onClick={() => this._login()}
                                                          className={Styles.textBold}>{this._renderText("item_7")}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default BoosterRegister;


// WEBPACK FOOTER //
// ./src/pages/booster-register/component.js